"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var StepTrackerContext = /*#__PURE__*/(0, _react.createContext)({
  steps: [],
  currentStep: 0,
  currentStepReferences: [],
  disableBackButton: true,
  showSubmitButton: false,
  buttonControlPressed: false,
  stepTrackerDisplayRef: null,
  OnNextStep: () => {},
  OnPreviousStep: () => {}
});
var _default = exports.default = StepTrackerContext;